import clsx from 'clsx';

interface Props {
  isOpen: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmVariant?: 'primary' | 'danger';
  isBusy?: boolean;
}

export function ConfirmDialog({
  isOpen,
  title,
  body,
  confirmLabel,
  cancelLabel = 'Annuleren',
  onConfirm,
  onCancel,
  confirmVariant = 'primary',
  isBusy = false,
}: Props) {
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-[60]" onClick={isBusy ? undefined : onCancel} />
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm pointer-events-auto">
          <div className="px-5 py-4 border-b border-slate-200">
            <h3 className="text-base font-semibold text-slate-900">{title}</h3>
          </div>
          <div className="px-5 py-4 text-sm text-slate-700 whitespace-pre-line">{body}</div>
          <div className="px-5 py-3 border-t border-slate-200 flex gap-2 justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={isBusy}
              className="px-3 py-1.5 text-sm font-medium text-slate-600 border border-slate-300 rounded-md hover:bg-slate-50 disabled:opacity-50"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isBusy}
              className={clsx(
                'px-3 py-1.5 text-sm font-medium rounded-md text-white disabled:opacity-50',
                confirmVariant === 'danger'
                  ? 'bg-red-600 hover:bg-red-700'
                  : 'bg-indigo-600 hover:bg-indigo-700'
              )}
            >
              {isBusy ? 'Bezig...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
